import axios, { Result } from "@/utils/axios";
import { LoginParams, UserData } from "@/types/login-type";
import { API_PRIFIX } from "@constants/common";

export const login = (data: LoginParams): Promise<Result<UserData>> => {
  return axios.post(`${API_PRIFIX}/user/loginIn`, data);
};

export const sendForgetLink = (data: { email: string }): Promise<any> => {
  return axios.post(`${API_PRIFIX}/user/sendForgetLink`, data, {
    timeout: 30000,
  });
};

export const resetPwd = (params: {
  code: string;
  password: string;
}): Promise<Result<any>> => {
  return axios.post(`${API_PRIFIX}/user/resetPwd`, params);
};
